import Decimal from 'decimal.js';

import { CurrencyConfig } from '../../types/widgetConfig';

// Past 7-day marketplace average for the selected period+currency.
// Source: widget-config.json → currencies[].investTickets[].interestRate.
// If the exact period isn't present (some currencies have sparse tickets),
// fall back to the nearest period's rate, then to minInterestRate.
export function lookupInterestRate(
  currencyConfig: CurrencyConfig,
  period: number
): string {
  const tickets = currencyConfig.investTickets;
  if (tickets.length === 0) {
    return currencyConfig.minInterestRate;
  }

  const exact = tickets.find(t => t.period === period);
  if (exact) return exact.interestRate;

  const nearest = tickets.reduce((best, t) =>
    Math.abs(t.period - period) < Math.abs(best.period - period) ? t : best
  );
  return nearest.interestRate;
}

export function isApproximateRate(
  currencyConfig: CurrencyConfig,
  period: number
): boolean {
  return !currencyConfig.investTickets.some(t => t.period === period);
}

export function lookupInterestRateDecimal(
  currencyConfig: CurrencyConfig,
  period: number
): Decimal {
  return new Decimal(lookupInterestRate(currencyConfig, period));
}
